import NumberTypes from "../enums/NumberTypes";

class PhoneNumber {
    id: number;
    phoneNumber: string;
    type: NumberTypes;
    createdOn: Date;
    editedOn: Date;
    createdBy: number;
    editedBy: number;

    constructor(data?: Partial<PhoneNumber>) {
        Object.assign(this, data);
    }
}

export default PhoneNumber;